var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav-bar'),_c('div',{staticClass:"relative"},[_c('router-view')],1),_c('Footer',{class:[
  _vm.currentRouteName === 'home' || 
  _vm.currentRouteName === 'company-profile' ||
  _vm.currentRouteName === 'find-providers'
   ? 'absolute bottom-4 left-0 right-0' : 'py-4']})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }